var viLang = {
	"src.Cart.CartDiscount.CartDiscountSeller.0": "Một số mã giảm giá có điều kiện đặc biệt, bạn cần",
	"src.Cart.CartDiscount.CartDiscountSeller.1": "Mã giảm giá/Phiếu mua hàng sẽ không thể khôi phục sau khi đặt hàng",
	"src.Common.PhoneLogin.PhoneLogin.0": "Sử dụng số điện thoại để Đăng nhập hoặc Đăng ký tài khoản của bạn",
	"src.mobile.ProductCard.ProductCard.0": "Sản phẩm này là đồ uống có cồn, quý khách cần xác nhận mình trên 18 tuổi để mua sản phẩm!",
	"src.mobile.ProductDetail.ProductShortDescriptionMobile.0": "Mô tả sản phẩm sẽ được cập nhật trong thời gian sớm nhất !"
};

export { viLang as default };
